module.exports = __webpack_public_path__ + "img/sync.6df66df3.svg";